import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { createSelectorHook, useDispatch } from 'react-redux';
import { testReducer } from './test';
import { idTokenReducer } from './idToken';
import { loginedReducer } from './logined';
import { adminsReducer } from './admins';
import { isPrintingReducer } from './isPrinting';

const reducer = combineReducers({
  test: testReducer,
  idToken: idTokenReducer,
  logined: loginedReducer,
  admins: adminsReducer,
  isPrinting: isPrintingReducer,
});

export const store = configureStore({
  reducer,
});

type RootState = ReturnType<typeof store.getState>;

// @ts-ignore
export const useTypedSelector = createSelectorHook<RootState>();
export declare type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
